module.exports = __webpack_public_path__ + "img/university.c52993ce.svg";